export enum LabelPositionIdentifier {
	Left = 0,
	Above,
	Right,
	Below
}
